module.exports = __webpack_public_path__ + "static/media/19-doggos-09_27_2020.029ea9e9.jpg";